export default {"src":"/_next/static/media/resources-002.b6d8dea0.svg","height":149,"width":211};